import IntlMessages from "../../../../util/IntlMessages";
import Checkbox from "../../../BP2Components/Checkbox";
import React from "react";
import { tDevForm } from "../../RenderDevEditForm";
import { Input } from "../../../BP2Components";
import "./SearchMethod.less";
import "../../RenderDevEditForm.less";

const SearchMethod = ({ state, setField, element }: tDevForm) => {
   return (
      <div className="dev-search-options">
         <div className="section-title">
            <IntlMessages id="devForm.searchMethod" />:
         </div>

         <div className="dev-search-options__block dev-form-row dev-form-row-gap-8">
            <input
               type="radio"
               name="searchMode"
               value="1"
               checked={state.seekingOut === "1"}
               onChange={() => {
                  setField?.("seekingOut", "1");
                  setField?.("seekingOutWithSearch", false);
                  setField?.("dedicatedSearchId", "");
               }}
            />
            <label>
               <IntlMessages id="devForm.dropdownList" />
            </label>
         </div>

         <div className="dev-search-options__block dev-form-row dev-form-row-gap-8">
            <input
               type="radio"
               name="searchMode"
               value="2"
               checked={state.seekingOut === "2"}
               onChange={() => setField?.("seekingOut", "2")}
            />
            <label>
               <IntlMessages id="devForm.dropdownListWithSearch" />
            </label>
         </div>
         {element.type !== "select" && (
            <div className="dev-form-col">
               <div className="dev-form-row dev-form-row-gap-8">
                  <input
                     type="radio"
                     name="searchMode"
                     value="3"
                     checked={state.seekingOut === "3"}
                     onChange={() => setField?.("seekingOut", "3")}
                  />
                  <label>
                     <IntlMessages id="devForm.dedicatedList" />
                  </label>
               </div>

               <div className="dev-form-row dev-form-row-gap-8 dev-search-options__with-search">
                  <Checkbox
                     disabled={state.seekingOut !== "3"}
                     checked={state.seekingOutWithSearch}
                     onChange={(e) => setField?.("seekingOutWithSearch", e.target.checked)}
                  />
                  <label>
                     <IntlMessages id="devForm.withSearch" />
                  </label>
               </div>

               {state.seekingOut === "3" && (
                  <div className="dev-form-col dev-search-options__with-search">
                     <label>
                        <IntlMessages id="devForm.listId" />:
                     </label>
                     <Input
                        type="text"
                        value={state.dedicatedSearchId}
                        onChange={(e) => setField?.("dedicatedSearchId", e.target.value)}
                        placeholder=""
                     />
                  </div>
               )}
            </div>
         )}

         <label className="dev-form-row dev-form-row-gap-8 dev-search-options__block">
            <input
               type="radio"
               name="searchMode"
               value="4"
               checked={state.seekingOut === "4"}
               onChange={() => setField?.("seekingOut", "4")}
            />
            <span>
               <IntlMessages id="devForm.searchByTextFragment" />
            </span>
         </label>

         <div className="dev-search-options__advanced">
            <label className="dev-form-row dev-form-row-gap-8">
               <Checkbox
                  checked={!!state.advansedSearch}
                  onChange={(e) => setField?.("advansedSearch", e.target.checked)}
               />
               <span>
                  <IntlMessages id="devForm.advancedSearch" />
               </span>
            </label>

            {state.advansedSearch && (
               <div className="dev-form-col dev-search-options__advanced">
                  <label>
                     <IntlMessages id="devForm.listId" />:
                  </label>
                  <Input
                     type="text"
                     value={state.advansedSearchId}
                     onChange={(e) => setField?.("advansedSearchId", e.target.value)}
                     placeholder=""
                  />
               </div>
            )}
         </div>
      </div>
   );
};

export default SearchMethod;
